import { createI18n } from 'vue-i18n'
import messages from "./lang";
// Init vue-i18n
const i18n = createI18n({
    locale: "fi",
    legacy: false,
    globalInjection: true,
    messages,
});

export default i18n;